import { type FC, useEffect, useState } from 'react'

import AnimatedCordWave from './assets/AnimatedCordWave.svg'

type LoaderProps = {
  delay?: number
}

export const Loader: FC<LoaderProps> = ({ delay = 500 }) => {
  const [show, setShow] = useState(delay <= 0)

  useEffect(() => {
    if (delay <= 0) {
      return
    }
    const timer = setTimeout(() => setShow(true), delay)
    return () => {
      clearTimeout(timer)
    }
  }, [delay])

  if (!show) return null

  return (
    <AnimatedCordWave
      width={200}
      height={200}
      style={{ width: '200px', height: '200px' }}
      data-testid="pzl-loader"
    />
  )
}
